import React from 'react';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { contactInfo } from '../mock';

const ContactPage = () => {
  return (
    <div className="min-h-screen" data-testid="contact-page">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-[#8B1538] to-[#A0252C] text-white py-20 relative overflow-hidden">
        <div className="absolute inset-0 bg-noise opacity-30"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Get In Touch
          </h1>
          <p className="text-xl text-[#F5E6D3] max-w-3xl mx-auto">
            Have questions about our appraisal services? Reach out using the details below.
          </p>
        </div>
      </section>

      {/* Contact Info Section */}
      <section className="py-20 bg-metallic-gold relative">
        <div className="absolute inset-0 bg-noise"></div>
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative space-y-6">
          <Card className="border-2 border-[#E8D5C4] shadow-lg" data-testid="contact-info-card">
            <CardHeader>
              <CardTitle className="text-2xl text-[#8B1538]">Contact Information</CardTitle>
            </CardHeader>
            <CardContent className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-gradient-to-br from-[#8B1538] to-[#A0252C] rounded-lg flex items-center justify-center flex-shrink-0 shadow-md">
                  <Phone className="w-6 h-6 text-white" />
                </div>
                <div>
                  <div className="font-semibold text-gray-900 mb-1">Phone</div>
                  <a href={`tel:${contactInfo.phone}`} className="text-[#8B1538] hover:underline" data-testid="contact-phone">
                    {contactInfo.phone}
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-gradient-to-br from-[#8B1538] to-[#A0252C] rounded-lg flex items-center justify-center flex-shrink-0 shadow-md">
                  <Mail className="w-6 h-6 text-white" />
                </div>
                <div>
                  <div className="font-semibold text-gray-900 mb-1">Email</div>
                  <a href={`mailto:${contactInfo.email}`} className="text-[#8B1538] hover:underline break-all" data-testid="contact-email">
                    {contactInfo.email}
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-gradient-to-br from-[#8B1538] to-[#A0252C] rounded-lg flex items-center justify-center flex-shrink-0 shadow-md">
                  <MapPin className="w-6 h-6 text-white" />
                </div>
                <div>
                  <div className="font-semibold text-gray-900 mb-1">Location</div>
                  <p className="text-gray-600">{contactInfo.address}</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-gradient-to-br from-[#8B1538] to-[#A0252C] rounded-lg flex items-center justify-center flex-shrink-0 shadow-md">
                  <Clock className="w-6 h-6 text-white" />
                </div>
                <div>
                  <div className="font-semibold text-gray-900 mb-1">Business Hours</div>
                  <p className="text-gray-600">{contactInfo.hours}</p>
                </div>
              </div>
            </CardContent>
          </Card>

          <Card className="border-2 border-[#D4A574]/40 bg-[#F5E6D3]/40">
            <CardHeader>
              <CardTitle className="text-xl text-[#8B1538]">Quick Response</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-700 text-sm">
                We typically respond to inquiries within 24 hours during business days. For urgent appraisal needs, please call us directly.
              </p>
            </CardContent>
          </Card>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
